import React from 'react'
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from "./RenderIf";

const Forecast = ({
    years='',
    just='',
    units='',
    forecastLow='',
    forecastHigh='',
    handleChange = function () {
        console.log("no function defined");
      },
}) => {

  if (forecastLow === '' || forecastLow === null){
    forecastLow = 0
  }
  if (forecastHigh === '' || forecastHigh === null){
    forecastHigh = 0
  }

  return (
    <General.BlockContainer>
    <General.Block>
      <FloatCard width="300px">
        <General.InputCont>
          <General.Input
          className='input'
            type="number"
            name="forecastYears"
            value={years}
            onChange={handleChange}
            placeholder=" "
            required
          />
          <General.Label className='placeholder' >Years in Future</General.Label>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <span >
            Justification
          </span>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <General.Text
          className='input'
            name="forecastJust"
            value={just}
            onChange={handleChange}
            placeholder=' '
            required
          ></General.Text>
          <General.Label className="placeholder" >Why this many years?</General.Label>
        </General.InputCont>
        <General.InputCont>
          <p>You can drag the lower right corner to make more room.</p>
        </General.InputCont>
        <General.InputCont>
          <RenderIf isTrue={!isNaN(forecastLow)}>
            <span>
              Low: {forecastLow.toFixed(2)} {units}
            </span>
          </RenderIf>
          <RenderIf isTrue={isNaN(forecastLow)}>
            Double check your numbers.
          </RenderIf>
        </General.InputCont>
        <General.InputCont>
          <RenderIf isTrue={!isNaN(forecastHigh)}>
            <span>
              High: {forecastHigh.toFixed(2)} {units}
            </span>
          </RenderIf>
          <RenderIf isTrue={isNaN(forecastHigh)}>
            Double check your numbers.
          </RenderIf>
        </General.InputCont>
      </FloatCard>
    </General.Block>
    <General.Block color={theme.colors.grey4}>
      <h2>Forecast Metric Range</h2>
    </General.Block>
  </General.BlockContainer>
  )
}

export default Forecast